import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/store";
import { GenderType } from "../../helpers/Enums";
import { useHistory } from "react-router-dom";
import { sendMessageToWebview } from "../../services/native";
import NiceModal from "@ebay/nice-modal-react";
import { getMyMemberDetails } from "../../services/memberService";
import { setUserData } from "../../redux/member";
import { cancelRecurringPaymentWeb } from "../../services/paymentService"; // הפונקציה שקוראת ל-API כדי לבטל המנוי
import ToastSnackbar from "../../components/ToastSnackbar"; // קומפוננטה להצגת הודעות בתחתית המסך
import { get } from "lodash";
import { debug } from "console";

const PremiumPlanDetails = () => {
  let member = useSelector((state: RootState) => state.member);
  const dispatch = useDispatch();
  let history = useHistory();
  let memberSubPlan: any;

  const [isLoading, setIsLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastSeverity, setToastSeverity] = useState<"success" | "error">(
    "success",
  );

  const subscriptionPlans = [
    {
      isLight: false,
      planName: "לא נמצא שם תוכנית",
      planPrice: "לא נמצא מחיר",
      planMonthlyPrice: "לא נמצא מחיר",
    },
    {
      isLight: false,
      planName: "חודש",
      planPrice: "79.90",
      planMonthlyPrice: "79.90",
    },
    {
      isLight: false,
      planName: "3 חודשים",
      planPrice: "179.90",
      planMonthlyPrice: "59.90",
    },
    {
      isLight: false,
      planName: "חצי שנה",
      planPrice: "239",
      planMonthlyPrice: "39.90",
    },
    {
      isLight: true,
      planName: "לייט",
      planPrice: "29.90",
      planMonthlyPrice: "29.90",
    },
  ];

  if (member.subscriptionPlanId !== null) {
    memberSubPlan = subscriptionPlans[member.subscriptionPlanId];
  } else {
    memberSubPlan = subscriptionPlans[0];
  }

  const openNativeSubSettings = () => {
    if (window.platform === "android" || window.platform === "ios") {
      sendMessageToWebview("open-store-subscription-settings");
    } else {
      NiceModal.show("action_modal", {
        onNext: () => {
          NiceModal.hide("action_modal");
        },
        headerTitle: "אפשרות הפסקת מנוי",
        contentTitle: "כרגע אפשר להפסיק מנוי רק באמצעות אפליקציית שושק'ה",
        primaryButtonText: "הבנתי",
        showCloseButton: false,
        showSeconderyButton: false,
      });
    }
  };

  const handleCancelRenewal = () => {
    const styleId = "modal-button-styles";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
      .MuiDialogActions-root button,
      .MuiDialogActions-root a {
        transition: background-color 0.3s ease, color 0.3s ease !important;
      }
      
      .MuiDialogActions-root button {
        background-color: red !important;
        color: white !important;
      }
      
      .MuiDialogActions-root a {
        background-color: transparent !important;
        color: black !important;
      }
    `;
      document.head.appendChild(style);
    }

    NiceModal.show("action_modal", {
      headerTitle: "ביטול חידוש מנוי",
      contentTitle: "האם ברצונך לבטל את חידוש המנוי?",
      primaryButtonText: "כן",
      seconderyButtonText: "לא",
      showCloseButton: true,
      showSeconderyButton: true,

      onNext: async () => {
        try {
          setIsLoading(true);
          console.log(
            "Attempting to cancel subscription with UID:",
            member.recurringPaymentUid,
          );

          const response = await cancelRecurringPaymentWeb(
            member.recurringPaymentUid,
          );

          // debugger;
          console.log("Cancel subscription response:", response);

          setToastMessage("המנוי בוטל בהצלחה!");
          setToastSeverity("success");
          setShowToast(true);

          // setTimeout(() => {
          //   NiceModal.hide("action_modal");
          // }, 1500);

          const { data } = await getMyMemberDetails(member.memberCode);
          dispatch(setUserData(data));

          NiceModal.show("action_modal", {
            headerTitle: "המנוי מבוטל",

            contentTitle: (
              <div style={{ padding: "0 70px", lineHeight: "1.6" }}>
                <p>חידוש המנוי שלך בוטל ולא תחוייב/י במועד החיוב הבא.</p>

                <p>
                  המנוי יישאר זמין עבורך עד תום תקופת המנוי שכבר שולמה, ללא כל
                  חיוב נוסף.
                </p>

                <p>
                  אם ברצונך לבצע הפסקה מיידית של המנוי, יש ליצור איתנו קשר
                  בכתובת{" "}
                  <a
                    href="mailto:shoshke@motke.co.il"
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    shoshke@motke.co.il
                  </a>
                </p>
              </div>
            ),
            primaryButtonText: "הבנתי",
            showCloseButton: true,
            showSeconderyButton: false,
            onNext: () => NiceModal.hide("action_modal"),
            onCancel: () => NiceModal.hide("action_modal"),
          });

          // TODO: ADD POPUP TO INFORM USER ABOUT SUCCESSFUL CANCELLATION AND REFRESH MEMBER DATA TO UPDATE THE UI
        } catch (error) {
          const errorMessage = get(
            error,
            "response.data.message",
            "אירעה שגיאה בביטול המנוי. אנא נסה שוב.",
          );
          setToastMessage(errorMessage);
          setToastSeverity("error");
          setShowToast(true);
          console.error("Error canceling subscription:", error);
        } finally {
          setIsLoading(false);
        }
      },
      onCancel: () => {
        NiceModal.hide("action_modal");
      },
    });
  };

  const membersSubscrptionFeatuers = () => {
    if (memberSubPlan!.isLight) {
      return (
        <>
          <li className="prem_info_item">
            <div className="prem_info_block option">
              <div className="prem_icon_block option">
                <img src="assets/images/ic_prem_9.svg" loading="lazy" alt="" />
              </div>
              <div className="prem_txt_block option">
                <div>
                  {member.genderId === GenderType.MALE ? "שלח" : "שלחי"} מתנות
                  עם הצעות ההיכרות
                </div>
              </div>
            </div>
          </li>
          <li className="prem_info_item">
            <div className="prem_info_block option">
              <div className="prem_icon_block option">
                <img src="assets/images/ic_prem_8.svg" loading="lazy" alt="" />
              </div>
              <div className="prem_txt_block option">
                <div>
                  {member.genderId === GenderType.MALE ? "גלה" : "גלי"} מי ביקר
                  בפרופיל שלך
                </div>
              </div>
            </div>
          </li>
        </>
      );
    } else {
      return (
        <>
          <li className="prem_info_item">
            <div className="prem_info_block option">
              <div className="prem_icon_block option">
                <img src="assets/images/ic_prem_12.svg" loading="lazy" alt="" />
              </div>
              <div className="prem_txt_block option">
                <div>
                  {" "}
                  {member.genderId === GenderType.MALE ? "שלח" : "שלחי"} הצעות
                  היכרות ללא הגבלה{" "}
                </div>
              </div>
            </div>
          </li>
          <li className="prem_info_item">
            <div className="prem_info_block option">
              <div className="prem_icon_block option">
                <img src="assets/images/ic_prem_8.svg" loading="lazy" alt="" />
              </div>
              <div className="prem_txt_block option">
                <div>
                  {member.genderId === GenderType.MALE ? "גלה" : "גלי"} מי ביקר
                  בפרופיל שלך
                </div>
              </div>
            </div>
          </li>
          <li className="prem_info_item">
            <div className="prem_info_block option">
              <div className="prem_icon_block option">
                <img src="assets/images/ic_prem_3.svg" loading="lazy" alt="" />
              </div>
              <div className="prem_txt_block option">
                <div>
                  {member.genderId === GenderType.MALE ? "גלוש" : "גלשי"} באופן
                  סמוי
                </div>
              </div>
            </div>
          </li>
          <li className="prem_info_item">
            <div className="prem_info_block option">
              <div className="prem_icon_block option">
                <img src="assets/images/ic_prem_9.svg" loading="lazy" alt="" />
              </div>
              <div className="prem_txt_block option">
                <div>
                  {member.genderId === GenderType.MALE ? "שלח" : "שלחי"} מתנות
                  עם הצעות ההיכרות
                </div>
              </div>
            </div>
          </li>
          <li className="prem_info_item">
            <div className="prem_info_block option">
              <div className="prem_icon_block option">
                <img src="assets/images/ic_prem_11.svg" loading="lazy" alt="" />
              </div>
              <div className="prem_txt_block option">
                <div>
                  {member.genderId === GenderType.MALE ? "דייק" : "דייקי"} את
                  העדפות החיפוש שלך
                </div>
              </div>
            </div>
          </li>
          <li className="prem_info_item">
            <div className="prem_info_block option">
              <div className="prem_icon_block option">
                <img src="assets/images/ic_prem_10.svg" loading="lazy" alt="" />
              </div>
              <div className="prem_txt_block option">
                <div>
                  {member.genderId === GenderType.MALE ? "הפעל" : "הפעילי"}{" "}
                  חיפושים וסינונים מתקדמים בפיד
                </div>
              </div>
            </div>
          </li>
          <li className="prem_info_item">
            <div className="prem_info_block option">
              <div className="prem_icon_block option">
                <img src="assets/images/ic_prem_13.svg" loading="lazy" alt="" />
              </div>
              <div className="prem_txt_block option">
                10% הנחה על השתתפות בפעילויות מוטק'ה
              </div>
            </div>
          </li>
        </>
      );
    }
  };

  const handleBack = () => {
    history.goBack();
  };

  console.log({ member });

  useEffect(() => {
    const refreshMemberData = async () => {
      try {
        const { data } = await getMyMemberDetails(member.memberCode);
        dispatch(setUserData(data));
      } catch (error) {
        console.error("Failed to refresh member data:", error);
      }
    };

    refreshMemberData();
  }, [dispatch, member.memberCode]); // הוסף את שניהם לarray

  return (
    <>
      <a
        href="#"
        onClick={handleBack}
        className="meet_close prem w-inline-block"
      >
        <img src="assets/images/ic_back_white.svg" loading="lazy" alt="" />
      </a>
      <section className="content_sec full wf-section" />
      <div className="content_sec full wf-section">
        <div className="content_block premium_opt">
          <div className="prem_options_group">
            <h1 className="center_title">המנוי שלי</h1>
            <div
              className="prem_order_details"
              style={{ position: "relative" }}
            >
              {member.isMemberPremiumFromStore ? (
                <>
                  <h3 className="prem_detais_title">התוכנית שלי:</h3>
                  <div className="prem_details_gr">
                    {memberSubPlan.isLight ? (
                      <>
                        <div className="prem_details_txt">חבילת פרימיום</div>
                        <div className="prem_details_txt var">
                          {memberSubPlan.planName}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="prem_details_txt">מנוי מתחדש כל</div>
                        <div className="prem_details_txt var">
                          {memberSubPlan.planName}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="prem_details_gr">
                    <div className="prem_details_txt">בעלות</div>
                    <div className="prem_details_txt var">
                      ₪{memberSubPlan.planMonthlyPrice}
                    </div>
                    <div className="prem_details_txt">לחודש</div>
                  </div>
                  <div className="prem_details_gr">
                    {member.isPremium_Renewing && (
                      <>
                        {" "}
                        <div className="prem_details_txt">מועד החיוב הבא:</div>
                        <div
                          style={{ marginLeft: "6px" }}
                          className="prem_details_txt var"
                        >
                          {member.subscriptionExpiryDate}
                        </div>
                        <div className="prem_details_txt psik">,</div>
                        <div className="prem_details_txt var">
                          ₪{memberSubPlan.planPrice}
                        </div>
                      </>
                    )}
                    {!member.isPremium_Renewing && (
                      <>
                        {" "}
                        <div className="prem_details_txt">
                          המנוי יסתיים בתאריך:
                        </div>
                        <div
                          style={{ marginLeft: "6px" }}
                          className="prem_details_txt var"
                        >
                          {member.subscriptionExpiryDate}
                        </div>
                      </>
                    )}
                  </div>
                </>
              ) : member.isMemberPremiumFromWeb ? (
                <>
                  <div className="prem_details_gr">
                    <h3 className="prem_detais_title">מנוי פעיל</h3>

                    {member.isPremium_Renewing ? (
                      <>
                        {/* <div className="prem_details_txt">מועד החיוב הבא:</div> */}
                        <div className="member-details-container">
                          <div>
                            <div className="prem_details_txt">
                              מתחדש בתאריך:
                            </div>
                            <div
                              style={{ marginLeft: "6px" }}
                              className="prem_details_txt var"
                            >
                              {member.subscriptionExpiryDate}
                            </div>
                          </div>
                          <div>
                            <div className="prem_details_txt var">
                              <span>סכום לחיוב:</span>
                              <span> </span>
                              <span>₪{member.subscriptionPriceWeb}</span>
                            </div>
                          </div>
                        </div>

                        {/* <button
                          style={{
                            position: "absolute",
                            bottom: "0",
                            padding: "0",
                            backgroundColor: "transparent",
                            color: "rgb(163, 0, 0)",
                            cursor: "pointer",
                            fontSize: "16px",
                            fontWeight: "500",
                            transition: "0.3s",
                          }}
                          onClick={() => handleCancelRenewal()}
                          onMouseEnter={(e) => {
                            // e.currentTarget.style.backgroundColor =
                            //   "rgb(211, 47, 47)";
                            // e.currentTarget.style.color = "rgb(255,0,0)";
                            e.currentTarget.style.color = "rgb(241, 47, 47)";
                          }}
                          onMouseLeave={(e) => {
                            // e.currentTarget.style.backgroundColor =
                            //   "transparent";
                            e.currentTarget.style.color = "rgb(163, 0, 0)";
                          }}
                        >
                          בטל חידוש
                        </button> */}
                      </>
                    ) : (
                      <>
                        {/* <div className="prem_details_txt">
                          המנוי יסתיים בתאריך:
                        </div> */}
                        <div className="prem_details_txt">מסתיים בתאריך:</div>
                        <div
                          style={{ marginLeft: "6px" }}
                          className="prem_details_txt var"
                        >
                          {member.subscriptionExpiryDate}
                        </div>
                      </>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="prem_details_gr">
                    <div className="prem_details_txt">
                      המנוי יסתיים ב {member.subscriptionExpiryDate}
                    </div>
                  </div>
                </>
              )}
            </div>
            <ul role="list" className="prem_info_list option w-list-unstyled">
              {membersSubscrptionFeatuers()}
            </ul>
          </div>
        </div>
      </div>
      <div className="nav_sec full wf-section">
        <div className="content_block footer">
          <a
            href="#"
            onClick={history.goBack}
            className="button_full premium_opt w-button"
          >
            הבנתי, תודה
          </a>
          <a
            href="https://www.motke.co.il/%D7%A2%D7%96%D7%A8%D7%94-%D7%A9%D7%95%D7%A9%D7%A7-%D7%94-%D7%A4%D7%A8%D7%99%D7%9E%D7%99%D7%95%D7%9D"
            target="_blank"
            className="skip_link premium"
          >
            למידע נוסף ועזרה
          </a>
          {member.isMemberPremiumFromStore && (
            <a
              href="#"
              onClick={openNativeSubSettings}
              className="skip_link premium"
            >
              ניהול וביטול המנוי
            </a>
          )}

          {member.isMemberPremiumFromWeb && member.isPremium_Renewing && (
            <button
              style={{
                backgroundColor: "transparent",
                color: "rgb(163, 0, 0)",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "500",
                transition: "0.3s",
              }}
              onClick={() => handleCancelRenewal()}
              onMouseEnter={(e) => {
                // e.currentTarget.style.backgroundColor =
                //   "rgb(211, 47, 47)";
                // e.currentTarget.style.color = "rgb(255,0,0)";
                e.currentTarget.style.color = "rgb(241, 47, 47)";
              }}
              onMouseLeave={(e) => {
                // e.currentTarget.style.backgroundColor =
                //   "transparent";
                e.currentTarget.style.color = "rgb(163, 0, 0)";
              }}
            >
              ביטול המנוי
            </button>
          )}
        </div>
      </div>
    </>
  );
};
export default PremiumPlanDetails;
